import Vue from 'vue';
import _ from 'underscore';
import Price from './Price';
import {P} from './Price';

class Pro {
    constructor(data, { rootState, context }) {

        this.id = data.id;
        this.order = data.order;
        this.code = data.code;
        this.type = data.type;
        this.formats = data.formats;
        this.availableSurfaces = data.availableSurfaces;
        this.availableLayouts = data.availableLayouts;
        this.active = data.active !== false;
        this.rootState = rootState;
        this.context = context;
        this.plu = data.plu || '';
        this.bundleSize = data.bundleSize;
        this.version = data.version || '';
    }

    apply(product) {
        console.log("product apply", {product});
        this.order = product.order || this.order;
        this.code = product.code;
        this.type = product.type;
        this.formats = product.formats;
        this.availableSurfaces = product.availableSurfaces;
        this.availableLayouts = product.availableLayouts;
        this.active = product.active;
        this.plu = product.plu;;
        this.bundleSize = product.bundleSize;
        this.version = product.version;

        if(product.price){
            this.price.apply(product.price)
            product.priceValue = this.price.price;
            this.price.price = product.price.price
            this.priceValue = this.price.price;
        }
        console.log("after update", this);
    }

    get getHTMLDescription() {
        return `${this.id} ${this.type} ${this.formats[0].displayString}`;
    }

    setContext(context) {
        if (this.price) {
            this.price.setContext(context);
        }
        this.context = context;
    }

    async save() {
        if (this.isDefault) {
            this.price.isDefault = true;
            return Vue.axios({ method: 'POST', url: `${this.rootState.config.productServicePort}/product`, data: this.toSave, headers: { Store: this.context } })
                .then(async () => {
                    await this.price.save();
                    this.isDefault = false;
                    return this;
                });
        }

        this.price.price = this.priceValue;
        await this.price.save();
        return await Vue.axios({ method: 'PUT', url: `${this.rootState.config.productServicePort}/product/${this.id}`, data: this.toSave, headers: { Store: this.context } });
    }

    delete() {
        return this.price.delete()
            .then(() => {
                return Vue.axios({ method: 'DELETE', url: `${this.rootState.config.productServicePort}/product/${this.id}`, headers: { Store: this.context } });
            });
    }

    get toSave() {
        return {
            id: this.id,
            order: this.order,
            code: this.code,
            type: this.type,
            formats: this.formats,
            availableSurfaces: this.availableSurfaces,
            availableLayouts: this.availableLayouts,
            active: this.active,
            plu: this.plu,
            bundleSize: this.bundleSize,
            version: this.version
        };
    }
}

class Product {
    constructor(rootState, context) {
        this.rootState = rootState;
        this.context = context;
    }

    async find() {
        const { data } = await Vue.axios({ method: 'GET', url: `${this.rootState.config.productServicePort}/product?all=true`, headers: { Store: this.context } });
        let commitPayload = data ? data.filter(item => item) : [];
        const result = _.map(commitPayload, (v) => {
            const tmp = [];
            const product = new Pro(_.clone(v), { rootState: this.rootState, context: this.context });
            tmp.push(product);
            return tmp;
        });

        commitPayload = _.flatten(result);
        this._products = commitPayload;
        return this._products;
    }

    async findWithPrices() {
        await this.find();
        const price = new Price(this.rootState, this.context);
        await price.find();
        this.mapPrices(price);
        return this.products;
    }

    async applyChanges(productsToAplly) {
        let isDefault = this._products.length === 0 ? true : false;
        if(isDefault){
            productsToAplly.forEach(p => {
                p.setContext(this.context)
                p.price.setContext(this.context)
                p.isDefault = isDefault
            })
            this._products = productsToAplly
        }else {
            console.group('product');
            this._products.forEach(product => {
                const productToAplly = productsToAplly.find(p => p.id === product.id);
                console.group('product apply');
                console.log({productToAplly, product});
                if(productToAplly){
                    product.apply(productToAplly)
                    product.isDefault = isDefault
                    console.log("product after applying ", {product});
                }
                console.groupEnd();
            })
            console.groupEnd();

            productsToAplly.forEach(p => {
                const foundProduct = this._products.find(pr => pr.id === p.id);

                if(!foundProduct){
                    p.setContext(this.context)
                    p.price.setContext(this.context)
                    p.isDefault = true
                    this._products.push(p)
                }
            })
        }
        return this;
    }

    mapPrices(price) {
        this.products = _.map(this._products, v => {
            v.price = price.priceForProduct(v.id);
            v.priceValue = Number(v.price.price);
            return v;
        });
    }

    get products() {
        return this._products;
    }

    set products(products) {
        this._products = products;
    }

    async groups() {
        const { data } = await Vue.axios({ method: 'GET', url: `${this.rootState.config.productServicePort}/product/group`, headers: { Store: this.context } });
        this._groups = data;
        return this.groups;
    }

    async save(){
        let promisesSave = []
        this._products.forEach(p => promisesSave.push(p.save()))
        return await Promise.all(promisesSave)
    }
}

export default Product;
